import { environment as env } from "../../../../environments/environment";

const GRUPOS_BASE_URL = env.ApiUrl + "v1/";
const REPORTING_URL = env.ApiUrl + "api"; // env.ReportingUrl;

export const GRUPOS_ENDPOINTS = {
    list: REPORTING_URL + "/organization/{id}/groups",
    item: GRUPOS_BASE_URL + "group/{id}",
    base: REPORTING_URL + "/group",
    log: GRUPOS_BASE_URL + "group-file/",
    // activation: GRUPOS_BASE_URL + '/{id}/activationToggle',
    idNames: REPORTING_URL + "/organization/{id}/operator",
    groupsByOperator:
        REPORTING_URL + "/organization/{id}/operator/{operatorId}/groups",
    // itemIdNames: GRUPOS_BASE_URL + '/{id}/items/idNames'
};

const MIEMBROS_BASE_URL = env.ApiUrl + "v1/";

export const MIEMBROS_ENDPOINTS = {
    list: REPORTING_URL + "/group/{id}/members",
    item: MIEMBROS_BASE_URL + "member_group/{id}/group/{groupId}",
    update: REPORTING_URL + "/member",
    create: REPORTING_URL + "/member",
    upload: MIEMBROS_BASE_URL + "uploadfile/group/",
    // activation: MIEMBROS_BASE_URL + '/{id}/activationToggle',
    // idNames:  MIEMBROS_BASE_URL + '/operator',
    // itemIdNames: MIEMBROS_BASE_URL + '/{id}/items/idNames'
};
